<template>
  <CCard class="dataTable py-5 mt-1" :class="{ pagePrint: this.$attrs.isPrint }">
    <CRow class="pt-2" :class="this.$attrs.isPrint ? 'py-1' : 'pb-4'">
      <CCol sm="12" class="d-flex flex-column">
        <div class="d-flex justify-content-between">
          <h2 class="titlePage font-weight-normal text-capitalize mb-4">
            {{ $t('campaign.campaignResult.resultTitle') }}
          </h2>
        </div>
        <div class="d-flex justify-content-between">
          <h4 class="titlePage font-weight-normal text-capitalize">
            {{ campaignResult.name }}
          </h4>
        </div>
      </CCol>
    </CRow>
    <CRow class="mt-4 rowBackPage">
      <CCol>
        <a
          @click="$router.push({ name: 'campaignList' })"
          class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600"
          style="cursor: pointer"
        >
          <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
          {{ $t('campaign.campaignResult.link.backToList') }}
        </a>
      </CCol>
    </CRow>
    <div v-if="isLoadingCampaignResult" class="d-flex justify-content-center align-items-center mt-4">
      <CSpinner color="primary" style="width: 4rem; height: 4rem" />
    </div>
    <CRow class="mt-5" v-if="showArea && !isLoadingCampaignResult">
      <CCol>
        <TabPanel :tabs="tabs">
          <TabArea tabName="Dashboard">
            <Dashboard :isPrint="this.$attrs.isPrint" :campaignResult="campaignResult" />
          </TabArea>
          <TabArea tabName="SMS">
            <SMS :campaignResult="campaignResult" />
          </TabArea>
          <TabArea tabName="Email">
            <Email :campaignResult="campaignResult" />
          </TabArea>
        </TabPanel>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import TabPanel from '../components/Result/TabPanel.vue'
import TabArea from '../components/Result/TabArea.vue'
import Dashboard from '../components/Result/Dashboard.vue'
import SMS from '../components/Result/SMS.vue'
import Email from '../components/Result/Email.vue'

export default {
  components: {
    TabPanel,
    TabArea,
    Dashboard,
    SMS,
    Email,
  },
  data() {
    return {
      campaignResult: {},
      tabs: ['Dashboard', 'SMS', 'Email'],
      showArea: false,
      isLoadingCampaignResult: true,
    }
  },
  mounted() {
    if (this.$route.params.campaignId) {
      this.getCampaignResult(this.$route.params.campaignId)
    }
  },
  methods: {
    getCampaignResult(campaignId) {
      this.isLoadingCampaignResult = true

      let organizationId = this.$route.params.organizationId
      services
        .getCampaignResult(organizationId, campaignId)
        .then((res) => {
          this.campaignResult = JSON.parse(JSON.stringify(res.data.data))
          this.removeTabs()
          let segmentsIds = this.getSegmentsFromSchedules([
            ...this.campaignResult.channels.sms.schedulings,
            ...this.campaignResult.channels.email.schedulings,
          ])

          this.getSegments(segmentsIds)
          this.getCampaign(organizationId, campaignId)

          this.showArea = true
        })
        .finally(() => {
          this.isLoadingCampaignResult = false
        })
    },

    getSegments(ids) {
      if (Array.isArray(ids)) {
        let organizationId = this.$route.params.organizationId
        let promisesList = []

        ids.forEach((elm) => {
          promisesList.push(services.getSegment(organizationId, elm))
        })

        if (promisesList.length > 0) {
          Promise.all(promisesList).then((res) => {
            this.loadSegmentsNames(res)
          })
        }
      }
    },

    getSenderName() {},

    getCampaign(organizationId, campaignId) {
      services
        .getCampaign(organizationId, campaignId)
        .then(({ data }) => {
          const RESPONSE = data.data
          const smsContents = RESPONSE.campaignWorkflow.values.filter((el) => el.channel == 2)

          this.campaignResult.channels.sms.schedulings.forEach((el) => {
            el.senderName = smsContents.filter((item) => item.schedulingId == el.schedulingId)[0].content.senderName || ''
          })
        })
        .catch((error) => {
          throw error
        })
        .finally(() => {})
    },

    getSegmentsFromSchedules(schedules) {
      if (Array.isArray(schedules)) {
        let segmentsResult = []
        schedules.forEach((elm) => {
          if (Array.isArray(elm.segments)) {
            elm.segments.forEach((el) => {
              if (segmentsResult.indexOf(el.segmentId) == -1) {
                segmentsResult.push(el.segmentId)
              }
            })
          }
        })
        return segmentsResult
      }
      return null
    },

    loadSegmentsNames(list) {
      if (Array.isArray(list)) {
        let idsNames = []
        list.forEach((elm) => {
          idsNames.push({
            // id: elm.data.data._id,
            id: elm.data.data.segmentId, // TODO REMOVER _id QUANDO FOR PARA A VERSÃO FINAL
            name: elm.data.data.name,
          })
        })

        this.loadSMSSegmentsNames(idsNames)
        this.loadEmailSegmentsNames(idsNames)
      }
    },

    loadSMSSegmentsNames(idsNames) {
      if (Array.isArray(this.campaignResult.channels.sms.schedulings)) {
        this.campaignResult.channels.sms.schedulings.forEach((elm) => {
          if (Array.isArray(elm.segments)) {
            elm.segments.forEach((el) => {
              el.segmentName = idsNames.find((e) => e.id === el.segmentId)?.name
            })
          }
        })
      }
    },

    loadEmailSegmentsNames(idsNames) {
      if (Array.isArray(this.campaignResult.channels.email.schedulings)) {
        this.campaignResult.channels.email.schedulings.forEach((elm) => {
          if (Array.isArray(elm.segments)) {
            elm.segments.forEach((el) => {
              el.segmentName = idsNames.find((e) => e.id === el.segmentId)?.name
            })
          }
        })
      }
    },

    removeTabs() {
      if (this.campaignResult.channels.email.schedulings.length === 0) {
        let emailIndex = this.tabs.indexOf('Email')
        if (emailIndex > -1) {
          this.tabs.splice(emailIndex, 1)
        }
      }
      if (this.campaignResult.channels.sms.schedulings.length === 0) {
        let smsIndex = this.tabs.indexOf('SMS')
        if (smsIndex > -1) {
          this.tabs.splice(smsIndex, 1)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.opacityIFrame {
  opacity: 0;
  pointer-events: none;
}
.pagePrint {
  padding: 3%;
  * {
    background: #fff;
  }
  .tab-bar,
  .colSearch,
  .rowBackPage {
    display: none;
    width: 0;
  }

  @media print {
    .email__section,
    .sms__section {
      display: block;
    }

    .email__item,
    .sms__item {
      * {
        page-break-inside: avoid;
      }
    }

    * {
      page-break-inside: avoid;
    }

    html,
    body {
      width: 210mm;
      height: 297mm;
    }
  }
}
</style>
